// src/pages/StatisticsPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Spinner from '../components/Spinner';
import StatisticsDashboard from '../components/StatisticsDashboard';

function StatisticsPage() {
  const { isAuthenticated, isInitializing } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isInitializing) return;
    if (!isAuthenticated) {
      navigate('/login');
    } else {
      setIsLoading(false);
    }
  }, [isInitializing, isAuthenticated, navigate]);

  if (isInitializing || isLoading) {
    return (
      <div className="container mx-auto max-w-5xl p-4 mt-16 flex justify-center items-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="container mx-auto max-w-5xl p-4 mt-16">
        <StatisticsDashboard />
      </div>
    </div>
  );
}

export default StatisticsPage;
